
import React from 'react';

const Certifications: React.FC = () => {
  const certifications = [
    {
      name: 'ISO 9001:2015',
      icon: 'ri-award-line',
      description: 'Quality Management System certification ensuring consistent quality in manufacturing and service delivery.',
      year: 'Certified 2016'
    },
    {
      name: 'Medical Device Manufacturing',
      icon: 'ri-health-book-line',
      description: 'Registered as a medical device manufacturer, enabling production of precision components for medical instruments.',
      year: 'Registered 2016'
    },
    {
      name: 'Promising SME Recognition',
      icon: 'ri-trophy-line',
      description: 'Selected as one of 300 promising small and medium enterprises by the Japanese government.',
      year: 'Awarded 2017'
    },
    {
      name: 'Regional Future Traction Company',
      icon: 'ri-building-line',
      description: 'Designated as a regional future traction company for contribution to local economic development.',
      year: 'Designated 2017'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#001E3C] mb-4">
            Certifications & Recognition
          </h2>
          <p className="text-xl text-gray-600">
            Committed to quality standards and industry excellence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-start">
                <div className="w-16 h-16 bg-gradient-to-br from-[#00D9C9] to-[#00B8AA] rounded-lg flex items-center justify-center flex-shrink-0 mr-6">
                  <i className={`${cert.icon} text-3xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#001E3C] mb-2">
                    {cert.name}
                  </h3>
                  <p className="text-[#00D9C9] font-semibold mb-3">
                    {cert.year}
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    {cert.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-lg p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-[#001E3C] mb-6 text-center">
            Quality Commitment
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-[#00D9C9] mb-2">100%</div>
              <p className="text-gray-600">Quality Inspection</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#00D9C9] mb-2">±0.001mm</div>
              <p className="text-gray-600">Precision Tolerance</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#00D9C9] mb-2">World-Class</div>
              <p className="text-gray-600">Technology Standards</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
